import React from 'react';
import { Instagram, Youtube, Mail } from 'lucide-react';
import { influencerData } from '../../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Youtube, href: '#', label: 'YouTube' },
    { icon: Mail, href: `mailto:${influencerData.email}`, label: 'Email' },
  ];

  return (
    <footer className="relative py-16 bg-[#0A0A0A] border-t border-[#D4AF37]/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo / Name */}
          <div>
            <a
              href="#"
              className="font-playfair text-2xl tracking-[0.3em] text-white hover:text-[#D4AF37] transition-colors duration-500"
            >
              ALEXANDRA STONE
            </a>
            <p className="text-[#A1A1AA] text-sm mt-2 tracking-wide">
              Elite Fitness Creator
            </p>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-6">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                aria-label={social.label}
                className="p-3 border border-[#D4AF37]/20 text-[#A1A1AA] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-all duration-300"
              >
                <social.icon size={20} />
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="my-10 h-[1px] bg-gradient-to-r from-transparent via-[#D4AF37]/20 to-transparent" />

        {/* Bottom Row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-[#A1A1AA] text-xs tracking-wide">
          <p>© {currentYear} Alexandra Stone. All rights reserved.</p>
          <div className="flex gap-8">
            <a href="#" className="hover:text-[#D4AF37] transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-[#D4AF37] transition-colors duration-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
